import React from 'react'
import { Route, Link, IndexRedirect, IndexRoute } from 'react-router'
import { connect } from 'react-redux'
import injectTapEventPlugin from 'react-tap-event-plugin'

import Login from './components/login'
import Home from './components/home'
import CheckOTP from './components/check-otp'
import ProvideDetails from './components/provide-details'
import ViewAsAdmin from './components/view-as-admin'
import LoggedOut from './components/logged-out'
import App from './app'
import Emails from './components/multiple-emails'
import ConfirmEmail from './components/confirm-email'
import serialize from 'serialize-javascript'

injectTapEventPlugin()

let ConnectedApp = connect(state => {
  const stateJSON = serialize(state, { isJSON: true })
  return {
    initialState: "window.__INITIAL_STATE__ = " + stateJSON
  }
})(App)

var routes = (
  <Route path='/' component={ConnectedApp}>
    {/* <IndexRedirect to='/login'/> */}
    <IndexRoute component={Home}/>
    <Route path='login' component={Login}/>
    <Route path='otp' component={CheckOTP}/>
    <Route path='confirm-email' component={ConfirmEmail}/>
    <Route path='provide-details' component={ProvideDetails}/>
    <Route path='view-as-admin/:idno'
      component={props => <ViewAsAdmin idno={props.params.idno} />}/>
    <Route path='emails' component={Emails}/>
    <Route path='loggedOut' component={LoggedOut}/>
  </Route>
)

module.exports = {
  routes: routes
}



// WEBPACK FOOTER //
// ./src/app/routes.js